<template>
  <div class="wxScan">
    <img :src="`/activity/api.php?m=public&subm=qrcode&url=${encodeURIComponent(URL)}`" alt="">
    <div class="note">请在微信中打开</div>
    <div class="btn" v-if="isClient" @click="btnClose">确定</div>
  </div>
</template>

<script>
export default {
  name: 'wxScan',
  computed: {
    URL() {
      return sessionStorage.getItem('URL')
    }
  },
  created() {
    // 判断环境，是否是客户端
      this.isClient = sessionStorage.getItem('isClient') === '1'
  },
  methods: {
    btnClose() {
      CP.close_page()
    }
  }
}
</script>

<style lang="stylus" scoped>
.wxScan
  text-align: center
  display: flex
  flex-direction: column
  align-items: center
  & > img
    margin: 0.7rem 0 0.24rem 0
    width: 2rem
    height: 2rem
    box-sizing: border-box
    padding: 0.1rem
  .note
    margin-bottom: 0.6rem
  .btn
    width: 0.96rem
    height: 0.3rem
    line-height: 0.3rem
    background-color: #ec4d5e
    border-radius: 0.06rem
    color: #fff
</style>


